// extracted by mini-css-extract-plugin
export default {"power-advice":"InverterRecommendation_power-advice__4JJxj"};